import BackendLayout from "../layouts/BackendLayout";
import { useState } from "react";
import { useDocumentTitle } from "../hooks";
import { getRouteBreadcrumb } from "../services/BreadcrumbServices";
import {PageTitle, Button, PageAlert, ButtonDPad, RedirectAlert} from "../components";
import { useMyPage } from "../hooks/MyPageHooks";
import ExpandablePanel from "../components/panels/ExpandablePanel";
import NotificationItem from "../components/cards/NotificationItem";
import Modal from "../components/modal/Modal";
import tenkenTheme from "../configs/themes/tenkenTheme";
import { formatDateTimeJapanese } from "../utils/datetime-utils";
import { FiXOctagon, FiKey } from "react-icons/fi";
import { readNoti, readNotifications } from "../api/my-page/fetch-api";
import store from "../store";
import { refreshNotifications } from "../store/actions";
import { useSelector } from "react-redux";
import { NotificationApprovalItem } from "../components/cards";
import _ from "lodash";
import { MY_PAGE } from "../constants/routes";
import { ModalNotifications } from "../components/modal";
import { errorStatusHandle } from "../utils";
import {MY_PAGE_PAGE} from "../constants/pageName";
import useRedirectPage from "../hooks/useRedirectPage";

export default function MyPage() {
  useRedirectPage(MY_PAGE_PAGE);
  const breadcrumb = getRouteBreadcrumb(MY_PAGE);
  useDocumentTitle(breadcrumb[breadcrumb.length - 1]?.menu + " - 点検王");
  const {
    notifications,
    setNotifications,
    allNotifications,
    approvalNotifications,
    supportValues,
  } = useMyPage();
  const [notiModal, setNotiModal] = useState(false);
  const [notification, setNotification] = useState({});
  const [approvalModal, setApprovalModal] = useState(false);
  const groupSettings = useSelector((s) => s.app_settings.machine_group);

  const refreshNotificationHeader = () => {
    const currentNotifications = store.getState().auth.notifications;
    if (!Array.isArray(notifications) || (currentNotifications?.total_unread === 0)) {
      return;
    }

    const newNotifications = {
      ...currentNotifications,
      total_unread: currentNotifications.total_unread -1
    };
    store.dispatch(refreshNotifications(newNotifications));
  };

  const handleReadNotification = (noti) => {
    // setNotification(noti);
    // setNotiModal(true);
    readNoti(noti)
      .then((res) => {
        const tmp = [...notifications];
        for (let idx = 0; idx < tmp.length; idx++) {
          if (tmp[idx].id === noti.id  && tmp[idx].status === 1) {
            tmp[idx]["status"] = 0;
            refreshNotificationHeader();
            break;
          }
        }
        setNotifications(tmp);
      })
      .catch((e) => {
        //
      });
  };

  const handleReadNotifications = async (noti) => {
    try {
      await readNotifications(noti);
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const listMachineGroup = (template) => {
    let groups = "";
    if (_.isEmpty(template)) {
      groups = "-";
    } else {
      for (let i = 1; i <= 5; i++) {
        if (groupSettings[`group_${i}`].active) {
          let group_name = "[ALL]";
          if (template[`group_${i}`] !== null) {
            group_name = template[`group_${i}`].name;
          }
          groups += group_name + "/";
        }
      }
    }
    groups = groups.slice(0, -1);
    return <span title={groups}>{groups}</span>;
  };

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <ButtonDPad />
      <PageTitle title={breadcrumb[breadcrumb.length - 1]?.menu} />
      <RedirectAlert />
      <PageAlert />
      <div className="flex gap-6">
        <div className="min-w-[300px] w-full max-w-[1300px]">
          <ExpandablePanel className="border border-tenken-gray-400 rounded-none">
            <ExpandablePanel.Header className="flex justify-between bg-[#E0E0E0] xl:p-[12px] p-[10px]">
              通知
            </ExpandablePanel.Header>
            <ExpandablePanel.Body>
              <div className="grid grid-row-7 gap-0]">
                {notifications?.length === 0 &&
                  approvalNotifications?.length === 0 && (
                    <p>現在、通知がありません。</p>
                  )}
                {approvalNotifications?.length > 0 && (
                  <NotificationApprovalItem
                    setOpenModal={setApprovalModal}
                    supportValues={supportValues}
                  />
                )}
                {notifications?.length > 0 &&
                  notifications?.map((row, idx) => (
                    <NotificationItem
                      notification={row}
                      onClick={() => handleReadNotification(row)}
                      key={idx}
                    />
                  ))}
              </div>
              {allNotifications?.length > 7 &&
                notifications?.length !== allNotifications?.length && (
                  <div className="py-[16px] flex justify-center">
                    <Button
                      color="gray"
                      className="min-w-[180px]"
                      onClick={() => setNotifications(allNotifications)}
                    >
                      すべての通知を表示
                    </Button>
                  </div>
                )}
            </ExpandablePanel.Body>
          </ExpandablePanel>
        </div>
      </div>
      <Modal
        dismissible
        show={notiModal}
        onClose={() => setNotiModal(false)}
        theme={tenkenTheme}
        size="sm"
      >
        <Modal.Header>
          <div className="flex">
            <div className="pt-1">
              {notification.type === "password_reset" && (
                <FiKey size={24} className="text-[#FCBD07]"></FiKey>
              )}
              {notification.type === "judgment_reject" && (
                <FiXOctagon size={24} className="text-[#DA0000]"></FiXOctagon>
              )}
            </div>
            <div className="ml-2">通知</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={"p-1"}>
            <div className="flex ">
              <div className="grow">
                <span className="">{notification.message}</span>
              </div>
            </div>
            <div className="text-right mt-1">
              <p className="text-sm">
                {formatDateTimeJapanese(notification?.created_at)}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flex justify-center">
          <Button
            className="w-[120px] rounded"
            theme={tenkenTheme.button}
            color="primary"
            onClick={() => setNotiModal(false)}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalNotifications
        openModal={approvalModal}
        setOpenModal={setApprovalModal}
        size="5xl"
        notifications={approvalNotifications}
        listMachineGroup={listMachineGroup}
        readNotifications={handleReadNotifications}
      />
    </BackendLayout>
  );
}
